import { getOneExpertQuery } from '../api/queries/getOneExpertQuery';
import { graphQLClient } from '@/client/services/api/clients/graphqlClient';
import { useQuery } from '@tanstack/react-query';

export const useGetOneExpert = (expertId: string | undefined) =>
  useQuery({
    enabled: !!expertId,
    queryKey: ['getOneExpert', expertId],
    queryFn: async () => {
      const data = await graphQLClient.request(getOneExpertQuery, { expertId: expertId! });

      return data.getOneExpert;
    },
  });
